import React          from 'react';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';

var clsx = require('classnames')

const useStyles = makeStyles(() => ({
    grid: {
        position:  'fixed',
        height:    100,
        maxWidth:  '90vw',
        left:      '50%',
        transform: 'translate(-50%, 0%)',
        display:   'grid',
    },
    unit: {
       cursor:          'pointer',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       color:           '#FFF',
       borderRadius:    '0.5em',
       border:          '1px solid #FFF'
    },
    shake: {
        animation:               'shake 0.5s',
        animationIterationCount: '0.5s',
    },
      dont_shake: {
    }
    
}))

type GridProps = {
    size:           number[];
    level:          number;
    target_size:    number;
    failureCounter: number;
    answer:         number;
    showAnswer:     boolean;
    handleClick:    (val: number) => void;
}

const Grid: React.FC<GridProps> = ({ 
    size, 
    level, 
    target_size,
    failureCounter, 
    answer,
    showAnswer,
    handleClick
 }) => {

 const classes = useStyles();

 const [shake, setShake]                     = React.useState(false)
 const [tooManyFailures, setTooManyFailures] = React.useState(false)

 React.useEffect(() => {
     if (failureCounter >= 2) {
         setTimeout(() => {
            setTooManyFailures(true)
         },1500)
     }
     else {
        setTooManyFailures(false)
     }
 },[failureCounter])



 const handleRejection = () => {
    setShake(true)
    setTimeout(() => {
       setShake(false)
    },500)
  }

  const click = (val: number) => {
    if (showAnswer) {
        return
    }
    if (val !== answer) {
        if (failureCounter === 2) {
            return
        }
        handleRejection()
    }
    handleClick(val)
  }

  const rootStyle = React.useMemo(() => {
      return {
         top:                 size[1]/2 + target_size/4 + 60,
         width:               /*level === 2 ? */500 /*: 250*/,
         gridTemplateColumns: `repeat(${ /*level === 2 ? */10/* : 5 */}, 1fr)`,
      }
  },[size, target_size/*, level*/])

  return (
        <div 
          className = { classes.grid }
          style     = { rootStyle }
        >
            {
                new Array(/*level === 2 ? */20/* : 10*/).fill(0).map((val, ind) => {

                    const value = /*level === 2 ? */ind + 1/* : ind + 10;*/

                    return (
                        <div 
                           key       = { `exercises_solutions${ ind }` }
                           className = { clsx(classes.unit, (shake ? classes.shake : classes.dont_shake)) }
                           onClick   = { () => { click(value) }}
                           style     = {{
                             backgroundColor: value === answer && (showAnswer || tooManyFailures) ? colors.green : colors.blue,
                             cursor:          showAnswer || tooManyFailures ? 'default' : 'pointer'
                           }}
                        >
                           { value }
                        </div>
                    )
                })
            }
        </div>
  );
}



export default Grid;








